module.exports = __webpack_public_path__ + "images/emoji/dolls.e3971eeec6cd0b8f6c6a.png";